module.exports = function(bootstrap) {

    'use strict';
    bootstrap.directive('newPassword', ["$q", "teamsite", function($q, teamsite) {

        //TODO: Replace duplicate logic in temporary-password.js / temporary-password.html by using this directive.

        return {
            restrict: 'A',
            replace: true,
            template: require('directives/newPassword.html'),
            require: ['^form'],
            scope: {
                passwordStrengthRules: '=', // password strength rules object, ex: { minLength: 8, maxLength: 64 }
                ignoreCurrentPassword: '=', // True if validation needs done against current password, false if not.
                showRegularPassword: '=',   // Indicates if the old password rules are used.
                showPasswordStrength: '=',  // Indicates if the new password rules are used.
                showDuplicatePassword: '=', // True if authprofile/password service returns 406 error.
                showNameInPassword: '=',    // True if authprofile/password service returns 406 error with PI found description.
                disableInputs: '=?',        // Boolean to disable all input fields (Optional).
                controls: '&'               // Returns object with control functions (validate) that can be called from the parent controller.
            },

            link: function(scope, element, attrs, ctrls) {
                scope.myForm = ctrls[0];
            },

            controller: ['$scope', '$state', '$cookies', 'services','brand', function($scope, $state, $cookies, services, brand) {

                $scope.disableInputs = false;
                $scope.invalidClass = '';

                $scope.passwordRules = {
                    oneNumber: false,
                    twoLetters: false,
                    properLength: false,
                    upperCase: false,
                    lowerCase: false,
                    specialChar: false,
                    containsSpace: false,
                    exceedLength: false,
                    minLength: true,
                    passwordsMatch: false
                };

                $scope.passwordVerifyRules = {
                    passwordMismatch: false,
                    required: true
                };

                if (!$scope.passwordStrengthRules || $scope.passwordStrengthRules === undefined) {
                    $scope.password = {
                        minLength: 8,
                        maxLength: $scope.showPasswordStrength ? 64 : 20
                    };
                } else {
                    $scope.password = $scope.passwordStrengthRules;
                }

                $scope.isMINCR = window.location.hostname.toLowerCase().indexOf('bluecrossmnonline.com') > -1;
                $scope.newPasswordUpdate = function() {
                    $scope.passwordRules = {
                        oneNumber: false,
                        twoLetters: false,
                        properLength: false,
                        correctCount: false,
                        specialChar: false,
                        containsSpace: false,
                        exceedLength: false,
                        minLength: false,
                        passwordsMatch: false
                    };
                    $scope.showDuplicatePassword = false;

                    var newPassword = $scope.myForm.newPassword.$viewValue;
                    var currentPassword = $scope.ignoreCurrentPassword === true ? "" : $scope.myForm.currentPassword.$viewValue;
                    var count = 0;

                    $scope.passwordSaved = false;

                    // Test length
                    if (newPassword && newPassword.length>=$scope.password.minLength && newPassword.length<=$scope.password.maxLength) {
                        $scope.passwordRules.properLength = true;
                    } else if(newPassword.length >= $scope.password.maxLength) {
                        $scope.passwordRules.exceedLength = true;
                    } else if(newPassword.length <= $scope.password.minLength) {
                        $scope.passwordRules.minLength = true;
                    }
                    // Test for two letters
                    if (newPassword && newPassword.length>0 && /[a-z].*[a-z]/i.test(newPassword)) {
                        $scope.passwordRules.twoLetters = true;
                    }
                    // Test for one number
                    if (/[0-9]/.test(newPassword)) {
                        $scope.passwordRules.oneNumber = true;
                        count++;
                    }
                    if (/[#!@$%^&*\(\)\-_=|;:'",.?`~\\\/\[\]\{\}]/.test(newPassword) && !(/[<>+]/).test(newPassword) ) {
                        $scope.passwordRules.specialChar = true;
                        count++;
                    }
                    if (newPassword.toLowerCase() !== newPassword) {
                        $scope.passwordRules.upperCase = true;
                        count++;
                    }
                    if (newPassword.toUpperCase() !== newPassword) {
                        $scope.passwordRules.lowerCase = true;
                        count++;
                    }

                    var trimmedPassword = newPassword.replace(/\s/g,'');
                    if (trimmedPassword != newPassword) {
                        $scope.passwordRules.containsSpace = true;
                    }
                    if (!$scope.ignoreCurrentPassword && newPassword == currentPassword) {
                        $scope.passwordRules.passwordsMatch = true;
                    } else {
                        $scope.passwordRules.passwordsMatch = false;
                    }
                    if(count > 3){
                        $scope.passwordRules.correctCount = true;
                    }
                };

                $scope.newPasswordVerifyUpdate = function(){

                    var verifiedPassword = $scope.myForm.newPasswordVerify.$viewValue;
                    var newPassword = $scope.myForm.newPassword.$viewValue;
                    $scope.showDuplicatePassword = false;
                    $scope.showNameInPassword = false;
                    $scope.passwordVerifyRules = {
                        passwordMismatch: false,
                        required: true
                    };

                    // Test length
                    if(verifiedPassword == undefined || verifiedPassword.length < 1){
                        $scope.passwordVerifyRules.required = true;
                    }else{
                        $scope.passwordVerifyRules.required = false;
                    }

                    //Tests verification of password
                    if((verifiedPassword != newPassword) && !$scope.passwordVerifyRules.required ){
                        $scope.passwordVerifyRules.passwordMismatch = true;
                    }
                };

                $scope.newPasswordValidate = function(){
                    if(!$scope.passwordRules.properLength || !$scope.passwordRules.correctCount){
                        $scope.invalidClass = 'ng-invalid';
                    }else{
                        $scope.invalidClass = '';
                    }
                };

                var controlFunctions = {
                    validate: function () {
                        var isValid = false;

                        if (!$scope.passwordRules.properLength ||
                                $scope.passwordRules.passwordsMatch ||
                                $scope.passwordVerifyRules.passwordMismatch ||
                                ($scope.showPasswordStrength && !$scope.passwordRules.correctCount) ||
                                $scope.passwordRules.containsSpace) {

                            $scope.myForm.$valid = false;
                            $scope.invalidClass = 'ng-invalid';
                            isValid = false;

                        } else {
                            $scope.invalidClass = '';
                            isValid = true;
                        }
                        return isValid;
                    }
                };
                $scope.controls({ controlsObject: controlFunctions });

            }]
        };
    }]);
};